import api from '../utils/api'

export const createGmo = async (gmo) => {

    try {
        const token = localStorage.getItem('token')

        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const body = {
            cidade: gmo.cidade,
            uf: gmo.uf,
            endereco: gmo.endereco,
            daOrigem: gmo.daOrigem,
        }

        const data = await api.post('/gmos/create', body).then((response) => {
            return response.data
        })

        return data


    } catch (error) {
        return null        
    }

}

export const getGmos = async (filter) =>{
    try {
        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(filter ? `/gmos${filter}`:`/gmos`).then((response) => {
            return response.data
        })

        return data


    } catch (error) {

        return null
        
    }
}

export const getGmoById = async (gmoId) =>{
    try {

        const token = localStorage.getItem('token');
    
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`

        const data = await api.get(`/gmos/${gmoId}`).then((response) => {
            return response.data
        })

        return data
        
    } catch (error) {

        return null        
    }
}

export const importarGmos = async (gmos) => {
    try {
        const token = localStorage.getItem('token');
        api.defaults.headers.Authorization = `Bearer ${JSON.parse(token)}`;

        const data = await api.post('/gmos/importar-gmos', { gmos }).then((response) => {
            return response.data;
        });

        return data;
    } catch (error) {
        return null;
    }
};

const GmoService = {
    createGmo,
    getGmos,
    getGmoById,
    importarGmos
}

export default GmoService